import React from 'react';
import { useReveal } from '../lib/useReveal';
import { ShieldCheckIcon } from '../lib/icons';
export function GuaranteeSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-159">
      <div className="container mx-auto max-w-3xl" data-id="element-160">
        <div ref={ref} className={`reveal bg-gradient-to-br from-[#111111] to-[#0a0a0a] border border-[#eab308]/30 rounded-2xl p-8 md:p-12 text-center shadow-[0_0_40px_rgba(234,179,8,0.1)] relative overflow-hidden ${vis ? 'is-visible' : ''}`} data-id="element-161">
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#eab308]/10 rounded-full blur-3xl" data-id="element-162"></div>
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-[#eab308]/10 rounded-full blur-3xl" data-id="element-163"></div>

          <div className="relative z-10" data-id="element-164">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#eab308]/10 border border-[#eab308]/20 mb-6" data-id="element-165">
              <ShieldCheckIcon className="w-8 h-8 text-[#eab308]" data-id="element-166" />
            </div>

            <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#eab308] mb-6 tracking-wide" data-id="element-167">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-168">
              <p data-id="element-169">Abrís los tomos. Los usás en tu práctica.</p>
              <p data-id="element-170">
                Si en 7 días no es lo que esperabas — devolución del 100%. Sin
                formularios. Sin drama.
              </p>
              <p className="text-gray-500 text-sm mt-6 pt-6 border-t border-white/10" data-id="element-171">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}